import { useCallback, useEffect, useState } from 'react';

import { debounce } from 'lodash/fp';

export const useQrState = (debounceTime = 2000) => {
  const [qrJson, setQrJson] = useState<string | null>(null);

  const debounceSetQrJson = useCallback(debounce(debounceTime, setQrJson), []);

  useEffect(() => {
    return () => {
      debounceSetQrJson.cancel();
    };
  }, [debounceSetQrJson]);

  return {
    qrJson,
    setQrJson,
    debounceSetQrJson,
  };
};
